import classes from './GlobalErrorCard.scss';
import SceButton from "../../../Common/CommonComponents/sceButton";
import { Link } from "react-router-dom";

const ErrorCard = (props) => {
  let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  let RefreshImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Refresh.svg';
  return (
    <div className={classes.errorBanner}>
      <div className={classes.errorMessageContainer}>
        <div className={classes.errorMessage}>
          <p className={classes.errorImage}><img src={warningImg} alt="Warning Image" /></p>
          <div className={classes.errorSingleStatement}>
            {/* {props.message} */}
            <div className={classes.errorSubtext}>
              {props.message}
            </div>
            <div className={classes.SceButton}>
              <SceButton
                iconType="return"
                buttonType="sceSmPrimary"
                value="Refresh "
                onClick={() => {props.contractResultReqprms ? props.refreshPage(props.contractResultReqprms.contractAccountNumber, props.contractResultReqprms.contractNumber, props.contractResultReqprms.premiseNumber,props.contractResultReqprms.isOpen, props.contractResultReqprms.contractBpNumber, props.contractResultReqprms.contractBpCategory) : props.refreshPage();}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorCard;